import { SelectOption } from '@tassat/ui-definitions';
import { createContext } from 'react';

export interface IConstantsContext {
    FIS_DDA_TIMEOUT: string;
}

const ConstantsContext = createContext<IConstantsContext | null>(null);
export { ConstantsContext };

/*         TIMERS/TIMEOUTS        */
export const FALLBACK_FIS_TIMEOUT = 4000;

/*         SYSTEM        */
export const emptySelectOption: SelectOption = {
    label: 'Select an option...',
    value: ''
};